import { createElement, FC, ReactNode } from 'react'
import clsx from 'clsx'

interface Props {
  id?: string
  type?: string
  children?: ReactNode
  className?: string
}

const Headline: FC<Props> = (props) => {
  let textClass
  let htmlTag
  switch (props.type) {
    case 'stage':
      htmlTag = 'h1'
      textClass = 'text-stage-m lg:text-stage font-bonprix whitespace-pre-wrap'
      break
    case 'h1':
      htmlTag = 'h1'
      textClass = 'text-h1-m lg:text-h1 font-bonprix whitespace-pre-wrap'
      break
    case 'h2':
      htmlTag = 'h2'
      textClass = 'text-h2-m lg:text-h2 font-bonprix whitespace-pre-wrap'
      break
    case 'h4':
      htmlTag = 'h4'
      textClass = 'text-h4 font-sans whitespace-pre-wrap'
      break
    default:
      htmlTag = 'h3'
      textClass = 'text-h3 font-bonprix whitespace-pre-wrap'
  }

  return createElement(
    htmlTag,
    { className: clsx(textClass + ' ' + (props.className || '')), id: props.id },
    props.children
  )
}

export default Headline
